export default function (level: string, maxLevel: string): boolean {
  switch (maxLevel) {
    case 'off':
      return ['off'].includes(level);
    case 'fatal':
      return ['off', 'fatal'].includes(level);
    case 'error':
      return ['off', 'fatal', 'error'].includes(level);
    case 'warn':
      return ['off', 'fatal', 'error', 'warn'].includes(level);
    case 'info':
      return ['off', 'fatal', 'error', 'warn', 'info'].includes(level);
    case 'debug':
      return ['off', 'fatal', 'error', 'warn', 'info', 'debug'].includes(level);
    case 'trace':
      return [
        'off',
        'fatal',
        'error',
        'warn',
        'info',
        'debug',
        'trace',
      ].includes(level);
    case 'all':
      return true;
    default:
      return false;
  }
}
